import { render } from "./App.vue?vue&type=template&id=4a56cae4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/denno/code/projects/welance/p110-hnf/p110-03-leadbot/frontend/forms/customer-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__